"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _AppIcon = _interopRequireDefault(require("../ImagesAndIcons/AppIcon"));

var _PageTitle = _interopRequireDefault(require("../TitlesAndTexts/PageTitle"));

var _InternalLink = _interopRequireDefault(require("../Navigation/InternalLink"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Theme
const Wrapper = _styledComponents.default.div.withConfig({
  displayName: "AppCard__Wrapper",
  componentId: "design-system__sc-13mk1rn-0"
})(["box-sizing:border-box;border:1px solid ", ";border-radius:", ";padding:1rem;display:flexbox;& > main{box-sizing:border-box;padding-left:1rem;}& > main > h2{padding-bottom:1rem;}& > main > a{display:block;}"], _BaseTheme.default.colors.lightgray, _BaseTheme.default.radius.regular);

const AppCard = _ref => {
  let {
    appId,
    appName,
    items,
    onClickIcon
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_AppIcon.default, {
    type: appId,
    size: "80",
    onClick: onClickIcon
  }), /*#__PURE__*/_react.default.createElement("main", null, /*#__PURE__*/_react.default.createElement(_PageTitle.default, null, appName), items.map(item => /*#__PURE__*/_react.default.createElement(_InternalLink.default, {
    to: item.path,
    key: item.path
  }, item.label))));
};

AppCard.propTypes = {
  appId: _propTypes.default.string.isRequired,
  appName: _propTypes.default.string.isRequired,
  items: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  onClickIcon: _propTypes.default.func
};
AppCard.defaultProps = {
  onClickIcon: undefined
};
var _default = AppCard;
exports.default = _default;